// Marketing images live in public/marketing/ (copied from the Lovable "violerts-launchpad" export).
export const asset = (filename) =>
	`${process.env.PUBLIC_URL || ''}/marketing/${filename}`;
